
import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Navbar({ darkText = false }: { darkText?: boolean }) {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { name: 'Antigua Guide', path: '/antigua-guatemala-travel-guide' },
    { name: 'Itineraries', path: '/itineraries' },
    { name: 'Things To Do', path: '/things-to-do-in-antigua-guatemala' },
    { name: 'Day Trips', path: '/day-trips-from-antigua-guatemala' },
    { name: 'Volcano Hikes', path: '/acatenango-hike-from-antigua' },
    { name: 'Transportation', path: '/guatemala-city-airport-to-antigua' },
    { name: 'Hotels', path: '/best-hotels-in-antigua-guatemala' },
    { name: 'Safety', path: '/is-antigua-guatemala-safe' },
  ];

  return (
    <nav className={`fixed w-full top-0 z-50 transition-all duration-300 ${
      isScrolled ? 'bg-white shadow-md' : darkText ? 'bg-white/80 backdrop-blur-sm' : 'bg-transparent'
    }`}>
      <div className="max-w-7xl mx-auto px-4">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center cursor-pointer">
            <img 
              src="https://static.readdy.ai/image/612c2ae47a27268c7e802411c60f5af5/654eefdeae24ccf8604ad66ae0f6cc69.png"
              alt="La Antigua Guatemala"
              className="h-12 w-auto"
            />
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden lg:flex items-center space-x-1">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`px-3 py-2 rounded-lg text-sm font-medium transition whitespace-nowrap cursor-pointer ${
                  location.pathname === link.path
                    ? 'text-teal-500'
                    : isScrolled || darkText
                    ? 'text-gray-700 hover:text-teal-500'
                    : 'text-white hover:text-teal-300'
                }`}
              >
                {link.name}
              </Link>
            ))}
          </div>

          {/* CTA Button */}
          <div className="hidden lg:block">
            <Link
              to="/plan-my-antigua-trip"
              className="bg-teal-500 hover:bg-teal-600 text-white px-6 py-2.5 rounded-lg font-semibold text-sm transition whitespace-nowrap cursor-pointer"
            >
              Plan My Trip
            </Link>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className={`lg:hidden w-10 h-10 flex items-center justify-center cursor-pointer ${
              isScrolled || darkText ? 'text-gray-900' : 'text-white'
            }`}
          >
            <i className={`text-2xl ${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div className="lg:hidden bg-white border-t border-gray-200">
          <div className="px-4 py-4 space-y-2">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                onClick={() => setIsMobileMenuOpen(false)}
                className={`block px-4 py-3 rounded-lg text-sm font-medium transition cursor-pointer ${
                  location.pathname === link.path
                    ? 'bg-teal-50 text-teal-500'
                    : 'text-gray-700 hover:bg-gray-50'
                }`}
              >
                {link.name}
              </Link>
            ))}
            <Link
              to="/plan-my-antigua-trip"
              onClick={() => setIsMobileMenuOpen(false)}
              className="block bg-teal-500 hover:bg-teal-600 text-white px-4 py-3 rounded-lg font-semibold text-sm text-center transition cursor-pointer"
            >
              Plan My Trip
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
}